import React from 'react'
import NotFound from '../notfound'

const NotFoundFr = () => {
    return <NotFound languageCode="fr" />
}

export default NotFoundFr
